(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        /*
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
        });
        */

        jQuery(function ($) {
          const $toggler = $('.navbar-toggler');

          // Get the collapse element Bootstrap actually controls
          const targetSel =
            $toggler.attr('data-bs-target') ||
            ('#' + $toggler.attr('aria-controls'));

          const $collapse = $(targetSel);

          // Safety: if selector didn't resolve, bail
          if (!$collapse.length) return;

          $collapse
            .on('show.bs.collapse', function () {
              $toggler.addClass('active');
              $('.navbar').addClass('active');
              $('body').addClass('navbar-active');
            })
            .on('hide.bs.collapse', function () {
              $toggler.removeClass('active');
              $('.navbar').removeClass('active');
              $('body').removeClass('navbar-active');
            });
        });
        

        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



////////////////////////////////////////////////////////////////////////////////////
/* REFRESH AOS ON Scroll */
/* Resolves issues with AOS scroll position miscalculation */
////////////////////////////////////////////////////////////////////////////////////
/*
let scrollRef = 0;
window.addEventListener('scroll', function() {
  // increase value up to 10, then refresh AOS
  scrollRef <= 10 ? scrollRef++ : AOS.refresh();
});
*/
jQuery(window).load(function($) {
  AOS.refresh();
})


//////////////////////////////////////////////////////////////////////////////////////
// Dropdown hover
////////////////////////////////////////////////////////////////////////////////////
jQuery(document).ready(function($) {
  $('.navbar-nav > li.dropdown').hover(
    function () {
      const $toggle = $(this).find('.js-dropdown-toggle');
      const $menu = $(this).find('.dropdown-menu');
      $toggle.addClass('show');
      $menu.stop(true, true).delay(200).fadeIn(200);
    },
    function () {
      const $toggle = $(this).find('.js-dropdown-toggle');
      const $menu = $(this).find('.dropdown-menu');
      $toggle.removeClass('show');
      $menu.stop(true, true).fadeOut(200);
    }
  );
});



/* THEME TOGGLE */
jQuery(document).ready(function($) {

  ////////////////////////////////////////////////////////////////
  // SECONDARY MENU TOGGLER
  ////////////////////////////////////////////////////////////////
  var $toggle = $('.secondary-menu-toggle');
  var $menu = $('.secondary-menu');

  $toggle.on('click', function() {
    $menu.toggleClass('active');
    $(this).toggleClass('open');
  });

  // Close dropdown when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.secondary-menu, .secondary-menu-toggle').length) {
      $menu.removeClass('active');
      $toggle.removeClass('open');
    }
  });

  ////////////////////////////////////////////////////////////////
  // THEME TOGGLER
  ////////////////////////////////////////////////////////////////
  document.querySelectorAll('.js-themeToggle').forEach(function(toggle) {
    toggle.addEventListener('change', function() {
      const obj = jQuery(this);
      const mode = obj.is(':checked') ? 'on' : 'off';

      if (mode === 'on') {
        jQuery('body').addClass('dove-theme-dark').find('.themeToggle').parent().addClass('on');
      } else {
        jQuery('body').removeClass('dove-theme-dark').find('.themeToggle').parent().removeClass('on');
      }

      // Save theme mode to PHP session
      localStorage.setItem('doveDarkThemeMode', mode);
      updateThemeToggle();

      // sync all .themeToggle instances together
      jQuery('.themeToggle').prop('checked', obj.is(':checked'));
      
    });
  });

  
  updateThemeToggle();
  

  function updateThemeToggle(){
    const savedMode = localStorage.getItem('doveDarkThemeMode'); // "on" or "off"
    const body = jQuery('body');
    const wrapper = jQuery('.js-toggle-wrapper');
    const toggle = jQuery(".js-themeToggle");

    if (savedMode === "on") {
      wrapper.addClass("on");
      toggle.prop('checked', true);
      body.addClass('dove-theme-dark');
    } else {
      wrapper.removeClass("on");
      toggle.prop('checked', false);
      body.removeClass('dove-theme-dark');
    }
    setTimeout(function(){
      wrapper.addClass('show');
      jQuery('.navbar-action-mobile')[0].offsetHeight;
      jQuery('.navbar-primary, .navbar-action-mobile').addClass('show');
    },400);
  }


  ////////////////////////////////////////////////////////////////
  // BRAND SCROLLER
  ////////////////////////////////////////////////////////////////
  var enabled = true;
  if($('.js-brand-carousel.scroller').length > 0 && enabled){
    var $carousel = $('.js-brand-carousel.scroller');
    var $track = $carousel.find('.marquee__track').first();
    var speed = 100; // pixels per second
    var paused = false;

    function scrollMarquee() {
        if (paused) {
            return;
        }

        var maxScroll = $track[0].scrollWidth - $carousel.width();
        var current = $carousel.scrollLeft();
        var remaining = maxScroll - current;

        if (remaining <= 1) {
          $carousel.addClass('is-fading');
          setTimeout(function () {
              $carousel.scrollLeft(0);
              $carousel.removeClass('is-fading');
              scrollMarquee();
          }, 300);
          return;
        }

        var duration = (remaining / speed) * 1000;

        $carousel.animate(
            { scrollLeft: maxScroll },
            duration,
            'linear',
            function () {
                scrollMarquee();
            }
        );
    }

    scrollMarquee();

    // Hover handling (unchanged)
    $carousel.hover(
        function () {
            paused = true;
            $carousel.stop(false);
        },
        function () {
            paused = false;
            scrollMarquee();
        }
    );
    
  }







  /*
  var paused = false;
  container.addEventListener('mouseenter', () => paused = true);
  container.addEventListener('mouseleave', () => paused = false);
  function autoScroll() {
    if (!paused) {
      container.scrollLeft += speed;
      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0;
      }
    }
    requestAnimationFrame(autoScroll);
  }
  */
 


  ////////////////////////////////////////////////////////////////
  // STICKY NAV SCROLL
  ////////////////////////////////////////////////////////////////
  $(window).on('scroll', function() {
    initStickyNaveScroll();
  });
  initStickyNaveScroll();

  function initStickyNaveScroll(){
    let scrollPos = $(window).scrollTop();
    if (scrollPos > 240) {
      jQuery('header.js-sticky-top').addClass('float');
    }else{
      jQuery('header.js-sticky-top').removeClass('float');
    }
  }


  ////////////////////////////////////////////////////////////////
  // NORMALIZE TICKER SPEED
  ////////////////////////////////////////////////////////////////
  jQuery(document).ready(function($) {
    var speed = 100;

    $('.js-flexi-quicklinks-row-text .marquee').each(function() {
      var $this = $(this);
      var contentWidth = $this.get(0).scrollWidth; // total scrollable width
      var duration = contentWidth / speed; // seconds

      $this.css({
        'animation-duration': duration + 's'
      });
    });
  });



  


  ////////////////////////////////////////////////////////////////
  // FOOTER MENU MOBILE DISPLAY
  ////////////////////////////////////////////////////////////////
  jQuery(function($) {
    const mobileBreakpoint = 992;

    // Store original HTML for restoration
    const originalMenus = {};
    $('#menu-footer-navigation-products, #menu-footer-navigation-secondary').each(function() {
      originalMenus[this.id] = $(this).html();
    });

    function setupCollapsibleMenu($menu, options) {
      const showCount = options.showCount || 0;
      const label = options.label || 'More';

      // Always restore original menu first
      $menu.html(originalMenus[$menu.attr('id')]);

      if ($(window).width() <= mobileBreakpoint) {
        const $items = $menu.find('> li.nav-item');
        if ($items.length <= showCount) return;

        // Create the "More" wrapper
        const $more = $('<li class="show-more"><button type="button d-inline-flex align-items-center flex-row"><span>' + label + '</span></button><ul class="hidden-items"></ul></li>');

        // Move hidden items into nested UL
        const $hiddenItems = $items.slice(showCount);
        $hiddenItems.appendTo($more.find('.hidden-items'));

        // Ensure hidden by default (prevents first-click issue)
        $more.find('.hidden-items').hide();

        // Insert it after visible items
        if (showCount > 0) {
          $items.eq(showCount - 1).after($more);
        } else {
          $menu.prepend($more);
        }
      }
    }

    // Toggle handler
    $(document).on('click', 'li.show-more > button', function(e) {
      e.preventDefault();
      const $parent = $(this).closest('.show-more');
      const $hiddenList = $parent.find('ul.hidden-items');

      const isExpanded = $parent.hasClass('expanded');
      if (isExpanded) {
        // Collapse
        $hiddenList.stop(true, true).slideUp(200);
        $parent.removeClass('expanded');
      } else {
        // Expand
        $hiddenList.stop(true, true).slideDown(200);
        $parent.addClass('expanded');
      }
    });

    function setupMenus() {
      setupCollapsibleMenu($('#menu-footer-navigation-products'), { showCount: 4, label: 'More Products' });
      setupCollapsibleMenu($('#menu-footer-navigation-secondary'), { showCount: 0, label: 'Navigation' });
    }

    // Run on load
    setupMenus();

    // Handle resize
    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setupMenus, 200);
    });
  });



});   // Document Ready


  
jQuery(document).ready(function ($) {
  
  jQuery(function ($) {
    
    const $header_blinds_container = $(".js-page-header-blinds");
    const $header_blinds = $(".js-page-header-blinds-piece");
    const totalBlinds = $header_blinds.length;
    let $header_full_range = ($(window).height() - ($(window).height() / 3)); // scroll distance to go from fully open → fully closed
    let headerScrollTopOffset = 0;
    
    function easeOutSept(t) {return 1 - Math.pow(1 - t, 10);}
    function updateHeaderBlinds() {
      if ($(window).width() > 2679) {
          headerScrollTopOffset = -($(window).height());  //-400
          $header_full_range = $('.page-header-carousel').height() + ($(window).height() - $header_blinds_container.height());  //-300  
      }
      if ($(window).width() < 2680) {
          headerScrollTopOffset = 100;
          $header_full_range = $('.page-header-carousel').height() - headerScrollTopOffset; 
      }
      if ($(window).width() < 768) {
          $header_full_range = $('.page-header-carousel').height() - headerScrollTopOffset; 
      }

      const rect = $header_blinds_container[0].getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= $(window).height()) return;

      let scrollProgress = (rect.top - headerScrollTopOffset) / $header_full_range;
      scrollProgress = Math.min(Math.max(scrollProgress, 0), 1);
      scrollProgress = 1 - scrollProgress; // Reverse if needed (scroll down = open)
      $header_blinds.each(function (i) {
          const totalOffset = 0.08; // stagger per blind
          let pieceProgress = scrollProgress - i * totalOffset;
          pieceProgress = Math.max(Math.min(pieceProgress, 1), 0);
          pieceProgress = easeOutSept(pieceProgress);
          $(this).css({
              "transform": "scaleY(" + pieceProgress + ")",
              "opacity": pieceProgress
          });
      });
    }
    
  function updateFooterBlinds() {
    const $footer_blinds_container = $(".js-page-footer-blinds");
    const $footer_blinds = $(".js-page-footer-blinds-piece");
    if ($footer_blinds_container.length === 0) return;

    const rect = $footer_blinds_container[0].getBoundingClientRect();

    // Calculate scroll range and offsets
    let $footer_full_range = ($(window).height() / 2) + $footer_blinds_container.height();
    let footerScrollTopOffset = ($('footer').height() / 2) - ($footer_blinds_container.height() - 50);

    if ($(window).width() > 767) {
        footerScrollTopOffset = $(window).height() - $('footer').height();
        $footer_full_range = $('footer').height() - ($footer_blinds_container.height() + 100);
    }
    if ($(window).width() < 768) {
        footerScrollTopOffset = ($('footer').height() / 2) - ($footer_blinds_container.height() + 150);
    }

    // Only animate if visible
    if (rect.bottom <= 0 || rect.top >= $(window).height()) return;
    
    let scrollProgress = (rect.top - footerScrollTopOffset) / $footer_full_range; // Scroll progress (0 → 1)
    scrollProgress = Math.min(Math.max(scrollProgress, 0), 1);
    scrollProgress = 1 - scrollProgress; // reverse for bottom → top animation
    const stagger = 0.08; // offset per blind for smooth sequential effect // Apply per-piece animation
    $footer_blinds.each(function (i) {
        const reverseIndex = totalBlinds - 1 - i;
        let pieceProgress = scrollProgress - reverseIndex * stagger;
        pieceProgress = Math.max(Math.min(pieceProgress, 1), 0);
        pieceProgress = easeOutSept(pieceProgress); // Strong easing for really smooth effect
        $(this).css({ // Apply both scale and opacity for clean appearance
            "transform": "scaleY(" + pieceProgress + ")",
            "opacity": pieceProgress
        });
    });
  }

  $(window).on("scroll resize", function () {
      updateHeaderBlinds();
      updateFooterBlinds();
  });
  updateHeaderBlinds();
  updateFooterBlinds();
});








  ////////////////////////////////////////////////////////////////
  // GALLERY CAROUSEL BLOCK - init flickity slider
  ////////////////////////////////////////////////////////////////
  jQuery(document).ready(function ($) {

    $('.js-flickity-gallery-slider').each(function () {

      const $slider = $(this);

      const flkty = new Flickity(this, {
        cellSelector: '.flexi-gallery-slider-cell',
        cellAlign: 'left',
        contain: true,
        groupCells: false,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: true
      });

      const $wrapper = $slider.closest('.js-flickity-gallery-wrapper').length
        ? $slider.closest('.js-flickity-gallery-wrapper')
        : $(document);

      //------------------------------------------------
      // AUTOSCROLL
      //------------------------------------------------

      let autoScroll;
      let resumeTimer;

      function startAutoScroll() {
        stopAutoScroll();
        autoScroll = setInterval(function () {
          flkty.next(true);
        }, 3000);
      }

      function stopAutoScroll() {
        clearInterval(autoScroll);
      }

      function resumeAutoScroll(delay = 2000) {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          startAutoScroll();
        }, delay);
      }

      startAutoScroll();

      //------------------------------------------------
      // HOVER PAUSE
      //------------------------------------------------

      $slider.on('mouseenter', stopAutoScroll);
      $slider.on('mouseleave', startAutoScroll);

      //------------------------------------------------
      // BUTTON NAVIGATION
      //------------------------------------------------

      $wrapper.find('.js-flexi-gallery-prev').on('click', function (e) {
        e.preventDefault();
        stopAutoScroll();
        flkty.previous();
        resumeAutoScroll(); // 2s delay
      });

      $wrapper.find('.js-flexi-gallery-next').on('click', function (e) {
        e.preventDefault();
        stopAutoScroll();
        flkty.next();
        resumeAutoScroll(); // 2s delay
      });

      //------------------------------------------------
      // DRAG INTERACTION
      //------------------------------------------------

      flkty.on('dragStart', stopAutoScroll);
      flkty.on('dragEnd', function(){
        resumeAutoScroll(); // 2s delay after drag
      });

    });

  });


  ////////////////////////////////////////////////////////////////
  // CROSSFADE CARD BLOCK - init flickity slider
  ////////////////////////////////////////////////////////////////
  if ($('.js-flickity-crossfade-slider').length) {
    const $crossfade_card_slider = $('.js-flickity-crossfade-slider');
    const visibleColumns = 1;
    let flktyInstance = null;

    function initCrossfadeSlider() {
      // destroy existing instance if present
      if (flktyInstance) {
        $crossfade_card_slider.flickity('destroy');
      }
      const slideCount = $crossfade_card_slider.find('.flexi-crossfade-slider-cell').length;
      const isMobile = window.innerWidth <= 768;
      // initialize Flickity
      $crossfade_card_slider.flickity({
        cellSelector: '.flexi-crossfade-slider-cell',
        cellAlign: isMobile ? 'center' : 'left',
        contain: true,
        groupCells: false,
        wrapAround: slideCount > visibleColumns,
        pageDots: false,
        prevNextButtons: false,
        draggable: true
      });
      flktyInstance = $crossfade_card_slider.data('flickity');
    }
    initCrossfadeSlider();

    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initCrossfadeSlider();
      }, 250);
    });

    // Custom controls
    $('.js-flexi-crossfade-prev').on('click', function () {
      if (flktyInstance) flktyInstance.previous();
    });

    $('.js-flexi-crossfade-next').on('click', function () {
      if (flktyInstance) flktyInstance.next();
    });
  }


  ////////////////////////////////////////////////////////////////
  // RELATED POST BLOCK - init flickity slider
  ////////////////////////////////////////////////////////////////
  if ($('.js-flickity-related-post-slider').length) {      
    const $related_post_card_slider = $('.js-flickity-related-post-slider');
    const visibleColumns = 4;
    let flktyInstance = null;

    function initRelatedPostSlider() {
      // destroy existing instance if present
      if (flktyInstance) {
        $related_post_card_slider.flickity('destroy');
      }
      const slideCount = $related_post_card_slider.find('.flickity-related-post-slider-cell').length;
      const isMobile = window.innerWidth <= 768;
      // initialize Flickity
      $related_post_card_slider.flickity({
        cellSelector: '.flickity-related-post-slider-cell',
        cellAlign: isMobile ? 'center' : 'left',
        contain: true,
        groupCells: false,
        wrapAround: slideCount > visibleColumns,
        pageDots: false,
        prevNextButtons: false,
        draggable: true
      });
      flktyInstance = $related_post_card_slider.data('flickity');
    }
    initRelatedPostSlider();

    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initRelatedPostSlider();
      }, 250);
    });

  }


  ////////////////////////////////////////////////////////////////
  // QUICK LINKS
  ////////////////////////////////////////////////////////////////

  jQuery(document).on('mouseenter mouseleave', '.js-flexi-quicklinks-row-text', function(e) {
    if (window.innerWidth > 992) {
      const img = jQuery(this).find('.flexi-quicklinks-row-image');
      img.css('position', 'absolute');

      if (e.type === 'mouseenter') {
        // Get mouse position and layout info
        const parentOffset = jQuery(this).offset().left;
        const mouseX = e.pageX;
        const viewportWidth = jQuery(window).width();
        const imageWidth = img.outerWidth();
        const offset = 20; // spacing between cursor and image

        let leftPos;

        // If near right edge, show image to the *left* of cursor
        if (mouseX + imageWidth + offset > viewportWidth) {
          leftPos = mouseX - imageWidth - offset;
        } else {
          // Otherwise, show it to the *right* of cursor
          leftPos = mouseX + offset;
        }

        // Prevent from going off the left edge
        if (leftPos < 0) {
          leftPos = 0;
        }

        // Convert to parent-relative position
        const relativeLeft = leftPos - parentOffset;
        img.css('left', relativeLeft + 'px');

        // Fade in
        img.show();
        setTimeout(function() {
          img.css({ 'opacity': '1' });
        }, 100);

      } else if (e.type === 'mouseleave') {
        // Fade out
        img.css({ 'opacity': '0' });
        setTimeout(function() {
          img.hide();
        }, 400);
      }
    }
  });


  ////////////////////////////////////////////////////////////////
  // TABBED DYNAMIC CONTENT
  ////////////////////////////////////////////////////////////////
  $('.tabbed-dynamic-content__tab').on('click', function () {
    const index = $(this).data('tab');

    // Update active tab
    $(this)
      .addClass('is-active')
      .siblings()
      .removeClass('is-active');

    // Update text content
    const $content = $(this)
      .closest('.tabbed-dynamic-content__left')
      .find('.tabbed-dynamic-content__text');
    $content.removeClass('is-active');
    $content.filter('[data-content="' + index + '"]').addClass('is-active');

    // Update image with fade
    const $images = $(this)
      .closest('.tabbed-dynamic-content')
      .find('.tabbed-dynamic-content__image');
    $images.removeClass('is-active');
    $images.filter('[data-image="' + index + '"]').addClass('is-active');
  });
  


  ////////////////////////////////////////////////////////////////
  // Gravity Form UI (SELECT)
  ////////////////////////////////////////////////////////////////
  $('.gfield--type-select .chosen-container').each(function() {
    const $container = $(this);
    const $select = $container.prev('select'); // Chosen attaches after the original select

    function toggleChosenClass() {
      const selectedText = $select.find('option:selected').text().trim();
      if (selectedText !== 'Select your enquiry type*' && selectedText !== '') {
        $container.addClass('option-selected');
      } else {
        $container.removeClass('option-selected');
      }
    }

    // Initial check
    toggleChosenClass();

    // When user changes selection
    $select.on('change', toggleChosenClass);
  });




  // TARGET NON-BREAKING SPACE
  $('p').filter(function() {
    return $(this).html().includes('&nbsp;');
  }).addClass('has-nbsp');

});



///////////////////////////////////////////////////////////
// PROJECTS ARCHIVE
///////////////////////////////////////////////////////////
jQuery(function ($) {
  function loadPage(pg, cat, pushHistory) {
    if (typeof pushHistory === "undefined") pushHistory = true;

    $.ajax({
      url: ajaxpagination.ajaxurl,
      type: "POST",
      dataType: "json",
      data: {
        action: "load_project_posts",
        pg: pg,
        cat: cat
      },
      beforeSend: function () {
        $(".projects-archive-section").addClass("opacity-50");
      },
      success: function (res) {
        if (res.success) {
          const cdg = $(".card-grid");
          cdg.toggleClass('featured-project-page', res.data.current == 1);
          cdg.html(res.data.posts);
          $(".projects-pagination").html(res.data.pagination);

          // keep states consistent after load
          syncFilters(cat);

          // update history
          if (pushHistory) {
            let newUrl = new URL(window.location);
            newUrl.searchParams.set("pg", pg);
            if (cat && cat !== "all") {
              newUrl.searchParams.set("cat", cat);
            } else {
              newUrl.searchParams.delete("cat");
            }
            history.pushState({ pg: pg, cat: cat }, "", newUrl);
          }
        }
      },
      complete: function () {
        setTimeout(() => {
          $("html, body").scrollTop(
            $(".projects-archive-section").offset().top - 250
          );
        }, 200);
        $(".projects-archive-section").removeClass("opacity-50");
      },
      error: function (xhr) {
        console.error("AJAX error:", xhr.responseText);
      }
    });
  }

  // Helper: sync pill <-> dropdown
  
  function syncFilters(cat) {
    $(".projects-filters-buttons .filter-btn").removeClass("active");
    if (cat && cat !== "all") {
      $('.projects-filters-buttons .filter-btn[data-cat="' + cat + '"]').addClass("active");
      $(".projects-filters-dropdown").val(cat);
    } else {
      $('.projects-filters-buttons .filter-btn[data-cat="all"]').addClass("active");
      $(".projects-filters-dropdown").val("all");
    }
  }

  // Pills (desktop)
  $(document).on("click", ".projects-filters-buttons .filter-btn", function () {
    let cat = $(this).data("cat");
    syncFilters(cat); // immediate sync
    loadPage(1, cat);
  });

  // Dropdown (mobile)
  $(document).on("change", ".projects-filters-dropdown", function () {
    let cat = $(this).val();
    syncFilters(cat); // immediate sync
    loadPage(1, cat);
  });

  // Pagination
  $(document).on("click", ".js-projects-pagination a", function (e) {
    e.preventDefault();
    let href = $(this).attr("href");
    let pg = new URL(href, window.location).searchParams.get("pg") || 1;
    let cat =
      $(".projects-filters-buttons .filter-btn.active").data("cat") ||
      $(".projects-filters-dropdown").val() ||
      "all";
    loadPage(pg, cat);
  });

  // Browser back/forward
  $(window).on("popstate", function (e) {
    let state = e.originalEvent.state;
    let pg = state && state.pg ? state.pg : 1;
    let cat = state && state.cat ? state.cat : "all";
    syncFilters(cat); // sync when navigating history
    loadPage(pg, cat, false);
  });
  

});






///////////////////////////////////////////////////////////
// LOCATIONS MAP
///////////////////////////////////////////////////////////
function initMap() {
  const mapOptions = {
    zoom: 5,
    center: { lat: -20.917574, lng: 142.702789 }, // Default: Brisbane
    styles: [
      { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
      { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
      { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
      { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
      { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
      { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
      { featureType: "administrative.country", elementType: "all", stylers: [{ visibility: "simplified" }] },
      { featureType: "administrative.country", elementType: "geometry", stylers: [{ visibility: "simplified" }] },
      { featureType: "administrative.country", elementType: "labels.text", stylers: [{ visibility: "simplified" }] },
      { featureType: "administrative.province", elementType: "all", stylers: [{ visibility: "off" }] },
      { featureType: "administrative.locality", elementType: "all", stylers: [{ visibility: "simplified" }, { saturation: "-100" }, { lightness: "30" }] },
      { featureType: "administrative.neighborhood", elementType: "all", stylers: [{ visibility: "off" }] },
      { featureType: "administrative.land_parcel", elementType: "all", stylers: [{ visibility: "off" }] },
      { featureType: "landscape", elementType: "all", stylers: [{ visibility: "simplified" }, { gamma: "0.00" }, { lightness: "74" }] },
      { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
      { featureType: "landscape.man_made", elementType: "all", stylers: [{ lightness: "3" }] },
      { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
      { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
      { featureType: "road", elementType: "geometry", stylers: [{ visibility: "simplified" }] },
      { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }] },
      { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: 0.2 }] },
      { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
      { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
      { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
      { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] }
    ]
  };

  const map = new google.maps.Map(document.getElementById("location-map"), mapOptions);
  const bounds = new google.maps.LatLngBounds();

  // --- [1] HELPER: Apply offset centering ---
  function offsetCenter(map, offsetFraction = 1 / 6) {
    const projection = map.getProjection();
    if (!projection) return;

    const center = map.getCenter();
    const point = projection.fromLatLngToPoint(center);
    const scale = Math.pow(2, map.getZoom());
    const mapDiv = map.getDiv();
    const mapWidthPx = mapDiv.offsetWidth;
    const xOffset = (mapWidthPx * offsetFraction) / scale;

    const newCenter = projection.fromPointToLatLng(
      new google.maps.Point(point.x + xOffset, point.y)
    );
    map.setCenter(newCenter);
  }

  // --- [2] TEXT MARKER CLASS ---
  class TextMarker extends google.maps.OverlayView {
    constructor(position, text, map) {
      super();
      this.position = position;
      this.text = text;
      this.div = null;
      this.setMap(map);
    }
    onAdd() {
      const wrapper = document.createElement("div");
      wrapper.classList.add("locations-marker");

      this.div = document.createElement("div");
      this.div.classList.add("locations-marker-text");
      this.div.innerHTML = `<i class="icon icon-ellipse"></i><span>${this.text}</span>`;
      wrapper.appendChild(this.div);

      this.getPanes().overlayLayer.appendChild(wrapper);
      this.wrapper = wrapper;
    }
    draw() {
      const projection = this.getProjection();
      const pos = projection.fromLatLngToDivPixel(this.position);
      if (pos && this.div) {
        this.div.style.left = pos.x + "px";
        this.div.style.top = pos.y + "px";
      }
    }
    onRemove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    }
  }

  // --- [3] CREATE MARKERS ---
  if (typeof flexiLocations !== "undefined" && flexiLocations.length > 0) {
    flexiLocations.forEach((loc) => {
      const coord = loc.coordinates;
      if (coord.lat && coord.lng) {
        const position = { lat: parseFloat(coord.lat), lng: parseFloat(coord.lng) };
        new TextMarker(position, loc.name, map);
        bounds.extend(position);
      }
    });

    map.fitBounds(bounds);

    google.maps.event.addListenerOnce(map, "bounds_changed", function () {
      if (map.getZoom() > 15) map.setZoom(15);
      offsetCenter(map);
    });

    // --- [4] RECENTER ONLY AFTER RESIZE STOPS ---
    let resizeTimer; // ⬅️ Added debounce timer
    google.maps.event.addDomListener(window, "resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        map.fitBounds(bounds);
        google.maps.event.addListenerOnce(map, "bounds_changed", function () {
          if (map.getZoom() > 15) map.setZoom(15);
          offsetCenter(map);
        });
      }, 300); // ⬅️ Adjust delay (ms) as desired
    });
  }
}




///////////////////////////////////////////////////////////
// LOCATIONS MAP
///////////////////////////////////////////////////////////
(() => {
    const initQuicklinkCards = () => {
        document.querySelectorAll('.section-flexi-quicklink-cards').forEach((section) => {
            const carousel = section.querySelector('.js-quicklink-cards-carousel');
            const slides = section.querySelectorAll('.js-quicklink-cards-slide');
            const progress = section.querySelector('.js-quicklink-cards-progress');
            const current = section.querySelector('.js-quicklink-cards-current');
            const mobileQuery = window.matchMedia('(max-width: 767.98px)');
            let flkty = null;

            if (!carousel || !slides.length || typeof Flickity === 'undefined') {
                return;
            }

            const updateControls = (index = 0) => {
                const slideCount = slides.length;
                const activeIndex = index + 1;
                const width = 100 / slideCount;

                if (current) {
                    current.textContent = activeIndex;
                }

                if (progress) {
                    progress.style.setProperty('--quicklink-progress-width', `${width}%`);
                    progress.style.setProperty('--quicklink-progress-offset', `${index * 100}%`);
                }
            };

            const initCarousel = () => {
                if (flkty) {
                    return;
                }

                flkty = new Flickity(carousel, {
                    cellAlign: 'left',
                    contain: false,
                    prevNextButtons: false,
                    pageDots: false,
                    draggable: true,
                    wrapAround: false,
                    imagesLoaded: true
                });

                flkty.on('change', updateControls);
                updateControls(flkty.selectedIndex);
            };

            const destroyCarousel = () => {
                if (!flkty) {
                    return;
                }

                flkty.destroy();
                flkty = null;
                updateControls(0);
            };

            const handleViewportChange = (event) => {
                if (event.matches) {
                    initCarousel();
                    return;
                }

                destroyCarousel();
            };

            handleViewportChange(mobileQuery);

            if (typeof mobileQuery.addEventListener === 'function') {
                mobileQuery.addEventListener('change', handleViewportChange);
            } else {
                mobileQuery.addListener(handleViewportChange);
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initQuicklinkCards, { once: true });
    } else {
        initQuicklinkCards();
    }
})();